// gift.js
'use strict';
import { fromJS } from 'immutable';
import {
  ADD_GIFTS,
  ADD_GIFT_CATEGORIES,
  // -- PLOP_PREPEND_REDUCER_ACTION_TYPE --
  LOGOUT,
} from '../ActionTypes.js';

export const defaultState = fromJS({
  categories: {},
  items: {},
});

/**
 * Gift.
 * @module reducer/gift
 */
const gift = (state = defaultState, action) => {
  switch (action.type) {
    case ADD_GIFTS:
      return _ADD_GIFTS(action.payload)(state);
    case ADD_GIFT_CATEGORIES:
      return _ADD_GIFT_CATEGORIES(action.payload)(state);
    // -- PLOP_PREPEND_REDUCER_SWITCH_CASE --
    case LOGOUT:
      return _LOGOUT(action.payload)(state);
    default:
      return state;
  }
};

/**
 * Add gifts
 * @kind reducer/actionType
 * @name ADD_GIFTS
 * @param {object} { gifts } - gift data
 * @return {Immutable.Map} New state
 */
const _ADD_GIFTS =
  ({ gifts }) =>
  state => {
    return state.update('items', items => items.mergeDeep(gifts));
  };

/**
 * Add gift categories
 * @kind reducer/actionType
 * @name ADD_GIFT_CATEGORIES
 * @param {object} { categories } - data
 * @return {Immutable.Map} New state
 */
const _ADD_GIFT_CATEGORIES =
  ({ categories }) =>
  state => {
    return state.update('categories', list => list.mergeDeep(categories));
  };

// -- PLOP_PREPEND_REDUCER_ACTION_HANDLER --

/**
 * Logout
 * @kind reducer/actionType
 * @name LOGOUT
 * @return {Immutable.Map} New state
 */
const _LOGOUT = () => () => {
  return defaultState;
};

export default gift;
